import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom'
import { DataTable, Modal } from '../components';
import { deleteCustomerById, getCustomers } from '../services';

const Customers = () => {
  const [deleteCustomerId, setDeleteCustomerId] = useState(null);
  const [customers, setCustomers] = useState([]);

  const openModal = (customerId) => {
    document.querySelector('.overlay').classList.toggle('modal__active');
    setDeleteCustomerId(customerId)
  }

  const deleteCustomer = () => {
    deleteCustomerById(deleteCustomerId).then(() => {
      document.querySelector('.overlay').classList.toggle('modal__active');
      const index = customers.findIndex((customer) => customer[0] === deleteCustomerId);
      customers.splice(index, 1);
      setDeleteCustomerId(null);
    })
  }

  useEffect(() => {
    // set customers from api request
    const body = [];
    getCustomers().then((res) => {
      res.customers.map((customer, i) => {
        const editIcon = <Link className="icon__edit" to={"customers/edit/"+customer.id}><i style={{marginRight: 30}} className="fas fa-pencil-alt"></i></Link>;
        const deleteIcon = <a onClick={() => openModal(customer.id)} className="icon__delete"><i className="fas fa-trash-alt"></i></a>;
        const row = [customer.id, customer.name, customer.contact, "Ja", editIcon, deleteIcon];
        body.push(row);
      });
      setCustomers(body);
    });
  }, []);

  const head = ["No", "Klantnaam", "Manager", "Actief", "Beheren", "Verwijderen"];
  if (customers) {
    return (
      <div className="container">
        <Modal header="Weet je zeker dat je deze klant wilt verwijderen?">
          <button onClick={deleteCustomer} className="button__delete">Verwijderen</button>
        </Modal>
        <h2 className="container__title">Klanten</h2>
        <div className="form__container">
          <DataTable head={head} body={customers} />
        </div>
      </div>
    );
  } else return <div></div>;
};

export default Customers;
